/**
 * Tabbed Slides Section
 * Interactive tabbed slides with carousel functionality using Splide.js
 */

(function() {
  function initTabbedSlides(sectionId, hasMultipleBlocks, ariaLabel) {
    const sectionContainer = document.getElementById('shopify-section-' + sectionId);
    if (!sectionContainer) return;

    const splideElementId = 'splide-' + sectionId;
    const splideElement = sectionContainer.querySelector('#' + splideElementId);
    if (!splideElement) return;

    const tabs = sectionContainer.querySelectorAll('.tabbed-slides__tab');
    const tabsContainer = sectionContainer.querySelector('.tabbed-slides__tabs');
    const prevButton = sectionContainer.querySelector('[data-nav-prev]');
    const nextButton = sectionContainer.querySelector('[data-nav-next]');
    const progressBar = sectionContainer.querySelector('[data-progress-bar]');

    let splideInstance = null;

    function updateTabs(index) {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('tabbed-slides__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive && tabsContainer && tab) {
          const containerWidth = tabsContainer.offsetWidth;
          const tabWidth = tab.offsetWidth;
          const tabLeft = tab.offsetLeft;
          const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);

          tabsContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      });
    }

    function updateNavigationButtons() {
      if (!hasMultipleBlocks || !splideInstance) return;

      const index = splideInstance.index;
      const total = tabs.length;

      if (prevButton) {
        prevButton.disabled = index === 0;
      }
      if (nextButton) {
        nextButton.disabled = index === total - 1;
      }
    }

    function updateProgressBar() {
      if (!progressBar || !hasMultipleBlocks || !splideInstance) return;

      const index = splideInstance.index;
      const total = tabs.length;
      const progressPercentage = ((index + 1) / total) * 100;
      progressBar.style.width = progressPercentage + '%';
    }

    function updateAll() {
      if (!splideInstance) return;

      const index = splideInstance.index;
      updateTabs(index);
      updateNavigationButtons();
      updateProgressBar();
    }

    function goToSlide(index) {
      if (splideInstance && index >= 0 && index < tabs.length) {
        splideInstance.go(index);
      }
    }

    function initSplide() {
      if (typeof Splide === 'undefined') {
        if (window.__splideReady) {
          window.__splideReady.then(function() {
            initSplide();
          });
        }
        return;
      }

      const config = {
        type: 'slide',
        autoplay: false,
        arrows: false,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: true,
        speed: 400,
        easing: 'linear',
        updateOnMove: true,
        perPage: 1,
        gap: '3rem',
        width: '100%',
        fixedWidth: '100%',
        breakpoints: {
          1023: {
            padding: { left: '1.5rem', right: '1.5rem' },
            gap: '0.5rem',
            fixedWidth: '40%',
          },
          768: {
            fixedWidth: '80%',
          },
        },
      };

      config.ariaLabel = ariaLabel || 'Tabbed slides';
      splideInstance = new Splide('#' + splideElementId, config);

      splideInstance.on('mounted', function() {
        updateAll();
      });

      splideInstance.on('moved', function() {
        updateAll();
      });

      splideInstance.mount();
    }

    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() {
        goToSlide(index);
      });

      tab.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToSlide(index);
        }
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        if (splideInstance) {
          const currentIndex = splideInstance.index;
          if (currentIndex > 0) {
            goToSlide(currentIndex - 1);
          }
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        if (splideInstance) {
          const currentIndex = splideInstance.index;
          if (currentIndex < tabs.length - 1) {
            goToSlide(currentIndex + 1);
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSplide);
    } else {
      initSplide();
    }
  }

  // Initialize all tabbed slides sections on the page
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('[data-tabbed-slides-section]');
    sections.forEach(function(section) {
      const sectionId = section.getAttribute('data-tabbed-slides-section');
      const hasMultipleBlocks = section.getAttribute('data-has-multiple-blocks') === 'true';
      const ariaLabel = section.getAttribute('data-aria-label') || 'Tabbed slides';
      initTabbedSlides(sectionId, hasMultipleBlocks, ariaLabel);
    });
  });
})();

